const isPhone = (value: any) => {
  const numberTestString = value.replace('+1 ', '').replace(/[()\s-+]/g, '');
  const numberTestRegex = /^\d{10,15}$/;
  return numberTestRegex.test(numberTestString);
};

export default isPhone;
